export default "__VITE_ASSET__BtVs8ve7__"